












import Vue from 'vue'

export default Vue.extend({
  name: 'CreditCardForm',
  props: ['gmoCardBrand', 'gmoCardNumber', 'gmoCardholderName', 'gmoCardExpire'],
  methods: {
    formatCardNumber(cardNumber: string): string {
      return '****' + cardNumber.substr(cardNumber.length - 4, 4)
    },
    formatExpire(expire: string): string {
      return expire.substr(2, 2) + '/' + expire.substr(0, 2)
    },
  },
})
